import { useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useRecommended() {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("/ListarRecomendados.php", {
      token: userData.token,
    });
    setList([...response.map((e) => ({ id: e, text: e }))]);
  }

  useEffect(() => {
    getData();
  }, []);

  return list;
}
